const Column = () => null

export default Column
